import { gql } from '@apollo/client';

export const QUERY_PERMISSION_OPERATION_LOG_BY_PAGE = gql`
  query QueryPermissionOperationLogByPage($condition: PermissionOperationLogQueryConditionInput, $pageRequest: PageRequestTypeInput) {
    queryPermissionOperationLogByPage(condition: $condition, pageRequest: $pageRequest) {
      content {
        id
        bizType
        bizId
        operationType
        operatorId
        operatorName
        operatedAt
        changesJson
      }
      page
      size
      totalElements
      totalPages
      hasNext
      hasPrevious
    }
  }
`;

export interface PermissionOperationLogQueryConditionInput {
  bizType?: number | null;
  bizId?: number | null;
  operationType?: number | null;
  operatorId?: number | null;
  operatorName?: string | null;
  operatedAtRange?: { start: string; end: string } | null;
}

export interface PermissionOperationLogItemType {
  id: number;
  bizType: number;
  bizId: number;
  operationType: number;
  operatorId: number;
  operatorName: string;
  operatedAt: number; // epoch seconds
  changesJson?: string | null;
}

export interface PermissionOperationLogPageResponseType {
  content: PermissionOperationLogItemType[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface QueryPermissionOperationLogByPageResponse {
  queryPermissionOperationLogByPage: PermissionOperationLogPageResponseType;
}

